import { LUDUM_ATTENDANCE_STATUSES, LUDUM_HEALTH_STATUSES } from '@/constants';
const { ATTENDING, NOT_ATTENDING } = LUDUM_ATTENDANCE_STATUSES;
const { ILL, INJURED } = LUDUM_HEALTH_STATUSES;
import get from 'get-object-path';

export const addResultsAttendance = {
    namespaced: true,

    state: {
        statuses: {},
        session: null
    },

    getters: {
        statuses(state) {
            return state.statuses;
        },

        preparedHealthStatuses(state) {
            const users = {};
            Object.values(state.statuses).forEach(({ user_id, not_attending, health_statuses, did_alternative }) => {
                users[user_id] = {
                    attending: not_attending ? NOT_ATTENDING : ATTENDING,
                    health_statuses,
                    did_alternative
                };
            });
            return users;
        }
    },

    mutations: {
        reset(state) {
            state.statuses = {};
            state.session = null;
        },

        setStatuses(state, session) {
            state.session = Object.assign({}, session);

            const participants = get(session, 'participants.data') || [];
            participants.forEach(participant => {
                Vue.set(state.statuses, participant.user_id, {
                    user_id: participant.user_id,
                    not_attending: get(participant, 'attendance.id') === NOT_ATTENDING,
                    health_statuses: { [ILL]: participant.ill, [INJURED]: participant.injured },
                    did_alternative: participant.did_alternative
                });
            });
        }
    },

    actions: {
        resetSessionAttendance(context) {
            context.commit('setStatuses', context.state.session);
        },

        setSessionAttendance(context, payload) {
            return context.dispatch('saveSessionAttendance', {
                data: {
                    event_id: payload.session.id,
                    users: context.getters.preparedHealthStatuses
                }
            });
        },

        saveSessionAttendance(context, payload) {
            return context.dispatch(
                'post',
                {
                    url: `${api}session-attendance`,
                    data: payload.data
                },
                { root: true }
            );
        }
    }
};

export default addResultsAttendance;
